module.exports = __webpack_public_path__ + "static/cardio-machine-5a9abdb2faa4d8dcc092a5928d5aee81.svg";